import * as React from "react";

import { selectIsPreviewMode } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

import { useSetCandidateNode } from "./candidateNode";
import { selectCanvasArea } from "./canvas-reducer";

export function useCanvasEnterLeaveMouseHandlers() {
  const canvasArea = useEditorSelector(selectCanvasArea);
  const isPreviewMode = useEditorSelector(selectIsPreviewMode);

  const { setCandidateNodeFromEvent, unsetCandidateNode } =
    useSetCandidateNode();

  React.useEffect(() => {
    if (isPreviewMode) {
      return;
    }

    function handleMouseLeave() {
      unsetCandidateNode();
    }

    // NOTE (Chance 2024-05-05): Casting window because TS struggles with the
    // event type overload if the element is typed as `HTMLElement | Window`.
    // MouseEvent is correct in either case.
    const _window = window as unknown as HTMLElement;
    const mouseEventsElement = canvasArea ?? _window;

    mouseEventsElement.addEventListener("mouseleave", handleMouseLeave);
    mouseEventsElement.addEventListener("mousemove", setCandidateNodeFromEvent);
    return () => {
      mouseEventsElement.removeEventListener("mouseleave", handleMouseLeave);
      mouseEventsElement.removeEventListener(
        "mousemove",
        setCandidateNodeFromEvent,
      );
    };
  }, [
    canvasArea,
    isPreviewMode,
    unsetCandidateNode,
    setCandidateNodeFromEvent,
  ]);
}
